import React from "react";
import '../../../styles/components/Services.css';

const Services = () => {
  const packages = [
    {
      name: "BASIC PACKAGE",
      price: "$300",
      tagline: "Starter Design Bundle",
      description: "Ideal for small businesses or individuals starting their brand.",
      features: [
        "Logo Design <small>(2 Concepts)</small>",
        "Business Card Design",
        "Flyer or Brochure <small>(1 Page)</small>",
        "Basic On-Page SEO Setup",
        "1 Social Media Banner Design",
      ],
      delivery: "5-7 DAYS",
    },
    {
      name: "PROFESSIONAL PACKAGE",
      price: "$800",
      tagline: "Brand Identity & Digital Presence",
      description:
        "Perfect for growing businesses seeking to establish a professional online & offline presence.",
      features: [
        "Logo Design <small>(3 Concepts + 1 Revision)</small>",
        "Full Branding Kit <small>(Business Card, Letterhead, Envelope)</small>",
        "Brochure/Flyer Design <small>(Up to 3 Pages)</small>",
        "Basic Website <small>(Up to 5 Pages)</small>",
        "On-Page SEO Optimization",
        "3 Social Media Banner Designs",
      ],
      delivery: "7-10 DAYS",
    },
    {
      name: "PREMIUM PACKAGE",
      price: "$1500",
      tagline: "Complete Digital Solution",
      description:
        "For established businesses looking for an all-in-one digital & branding solution.",
      features: [
        "Logo Design <small>(5 Concepts + Unlimited Revisions)</small>",
        "Full Branding Kit + Packaging Design",
        "Full Custom Website Design <small>(Up to 10 Pages)</small>",
        "E-commerce Integration <small>(If Needed)</small>",
        "Advanced SEO <small>(On-Page + Off-Page)</small>",
        "Social Media Management <small>(1 Month)</small>",
        "Digital Marketing Strategy <small>(PPC, Email Campaigns, etc.)</small>",
      ],
      delivery: "14-21 Days",
    },
  ];


  return (
    <section id="services" className="services">
      <div className="title-container">
        <h2 className="services-title">OUR SERVICES_</h2>
      </div>
      <div className="services-section"> 
          {packages.map((pkg, index) => (
            <div className="services-container">
              <div className="service-card" key={index}>
                <div className="card-header">
                  <h3>{pkg.name}</h3>
                  <p>{pkg.tagline}</p>
                  <h4>{pkg.price}</h4>
                </div>
                <div className="card-content">
                  <p className="card-description">{pkg.description}</p>
                  <ul className="features-list">
                    {pkg.features.map((feature, featureIndex) => (
                      <li key={featureIndex} dangerouslySetInnerHTML={{ __html: feature }}/>
                    ))}
                  </ul>
                  <p className="delivery">DELIVERY: {pkg.delivery}</p>
                </div>
              </div>
              <div className="book-now-button">
                <button className="book-button">Book Now</button>
              </div>
            </div>
          ))}
      </div>
    </section>

  );
};

export default Services;
